module.exports = __webpack_public_path__ + "static/media/construction-and-tools.2720d394.svg";